export const messages = {
  en: {
    reportNoFeeRoom: {
      search: {
        title: 'Search Conditions',
        floor: 'Select Building',
        unit: 'Select Unit',
        room: 'Select Room',
        ownerName: 'Owner Name',
        link: 'Owner Phone'
      },
      list: {
        title: 'No Fee Rooms',
        tooltip: 'Rooms not associated with fee items'
      },
      table: {
        index: 'No.',
        floor: 'Building',
        unit: 'Unit',
        room: 'Room',
        ownerName: 'Owner Name',
        link: 'Owner Phone'
      },
      exportSuccess: 'Export started successfully',
      exportFailed: 'Export failed'
    }
  },
  zh: {
    reportNoFeeRoom: {
      search: {
        title: '查询条件',
        floor: '请选择楼栋',
        unit: '请选择单元',
        room: '请选择房屋',
        ownerName: '业主名称',
        link: '业主电话'
      },
      list: {
        title: '未收费房屋',
        tooltip: '未关联收费项的房屋信息'
      },
      table: {
        index: '序号',
        floor: '楼栋',
        unit: '单元',
        room: '房屋',
        ownerName: '业主名称',
        link: '业主电话'
      },
exportSuccess: '導出任務已開始',
      exportFailed: '導出失敗'
    }
  },
  'zh-TW': {
    reportNoFeeRoom: {
      search: {
        title: '查詢條件',
        floor: '請選擇樓棟',
        unit: '請選擇單元',
        room: '請選擇房屋',
        ownerName: '業主名稱',
        link: '業主電話'
      },
      list: {
        title: '未收費房屋',
        tooltip: '未關聯收費項的房屋信息'
      },
      table: {
        index: '序號',
        floor: '樓棟',
        unit: '單元',
        room: '房屋',
        ownerName: '業主名稱',
        link: '業主電話'
      },
      exportSuccess: '導出任務已開始',
      exportFailed: '導出失敗'
    }
  }
}